import { produce } from 'immer';
import { AnyAction } from 'redux';

import { IResponseStatus } from '../../../_helpers/iResponse';
import { GET_REFERENTIALS_SUCCESS } from '../constants';

export interface IReferential {
  value: string;
  label: string;
}

export interface IReferentials {
  [key: string]: {
    data: IReferential[];
    label: string;
  };
}

interface IReferentialState {
  referentials: IReferentials;
}
export interface IResponseReferential extends IResponseStatus {}

const initState: IReferentialState = {
  referentials: {}
};

const referentialReducer = produce((draft = initState, action: AnyAction) => {
  switch (action.type) {
    case GET_REFERENTIALS_SUCCESS:
      draft.referentials = action.payload;
      break;
    default:
      return draft;
  }
});

export default referentialReducer;
